import React from "react";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import MainPokemon from "./MainPokemon";

const Main = () => {
  return (
    <section style={{ width: "100%", padding: "1rem", background: "#006dac" }}>
      <Router basename="/lista-pokemon">
        <Switch>
          <Route exact path="/" component={MainPokemon} />
          <Route path="*" children={<h2>error 404 not found</h2>} />
        </Switch>
      </Router>
    </section>
  );
};

export default Main;
